import { Link } from "react-router-dom";
import { isNativeIosApp } from "@/lib/platform";

export function PublicFooter() {
  const isNativeIos = isNativeIosApp();

  return (
    <footer className="bg-background border-t border-border py-12">
      <div className="container-app">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-bold">
              <span className="bg-gradient-to-br from-pink-500 to-purple-500 bg-clip-text text-transparent font-bold animate-gradient-subtle">Buukd</span>
            </Link>
            <p className="mt-2 text-sm text-muted-foreground">
              © {new Date().getFullYear()} Buukd. All rights reserved.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/#solutions" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Our Solutions
                </Link>
              </li>
              {!isNativeIos && (
                <li>
                  <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Pricing
                  </Link>
                </li>
              )}
              <li>
                <Link to="/faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/signin" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Sign in
                </Link>
              </li>
              {!isNativeIos && (
                <li>
                  <Link to="/signup" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Get Started
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
